module.exports = __webpack_public_path__ + "static/media/undraw_developer_activity_re_39tg.26549b77.svg";